
import React, { memo } from 'react';
import ReportTable from '../ui/ReportTable';

interface TableSectionProps {
  content: string;
  index: number;
}

const TableSection: React.FC<TableSectionProps> = ({ content, index }) => {
  return (
    <div key={index} className="my-6">
      <ReportTable content={content} />
    </div>
  );
};

export default memo(TableSection);
